export const home = {
  blank: 'Blank',
  appointmentSplash: 'Welcome to the appointment splash screen',
  translatedText: 'Translated text',
};
